import React from "react";
import logoImage from "../../assets/images/favicon.png";

export default function Footer() {
    return (
        <a
            className="fixed bottom-0 right-0 flex items-center justify-center h-8 pl-1 pr-2 mb-6 mr-4 text-blue-100 bg-slate-800 rounded-full shadow-lg hover:bg-slate-900"
            href="https://programmertowheed.com"
            target="_blank"
        >
            <div className="flex items-center justify-center w-6 h-6 bg-blue-500 rounded-full">
                <img
                    className="rounded-full w-6 h-6"
                    src={logoImage}
                    alt="LWS Logo"
                />
            </div>
            <span className="ml-1 text-sm leading-none">
                Programmer Towheed
            </span>
        </a>
    );
}
